/*********************************************************
 *                  Admin users Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("DriverCtrl", [
		"$scope", "companies", "Utils", "drivers", "$uibModal", "DriverService", "toastr", "$location",
		function ($scope, companies, Utils, drivers, $uibModal, DriverService, toastr, $location) {

		/************************************************************************************************************
			 *  SETUP
			 *************************************************************************************************************/

		$scope.data = {
			drivers: drivers.data,
			companies: companies.data,
			newDriver : {}
		};

		var importModal, deleteModal;


		/************************************************************************************************************
			 *  Redirection
			 *************************************************************************************************************/
		$scope.goToInsertDriver = function () {
			$location.url("manager/drivers/new");
		};

		/************************************************************************************************************
			 *  $scope functions
			 *************************************************************************************************************/
		/**
			 * Ouvrir la modal de suppression d'un driver.
			 */
		$scope.openDeleteModal = function (driver) {
			$scope.data.entityToDelete = driver;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
			 * Ouvrir la modal d'import d'un driver.
			 */
		$scope.openImportModal = function () {
			$scope.data.newDriver = {};
			importModal = Utils.openModal($uibModal, "import.html", $scope);
		};


		/**
			 * Lancer l'importation du CSV
			 */
		$scope.startImport = function () {
			DriverService.importCsv($scope.data.newDriver).then(() => {
				DriverService.getAllDriversByClient().then((response) => {
					$scope.data.drivers = response.data;
				});
				toastr.success("", "Conducteur(s) ajouté(s)");
				importModal.close();
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'importation."), "Erreur");

			});
		};


		/**
			 * Vérification taille upload fichier et traitement.
			 * @param files
			 */
		$scope.uploadFile = function (files) {
			if (files && files.length > 0) {
				$scope.$apply(function () {
					if (files[0].size > 4000000) {
						toastr.error("Votre fichier est trop volumineux.", "Taille de votre fichier");
						angular.element("input[type='file']").val(null);

						$scope.data.newDriver.acceptUploadFile = false;
					}
					else {
						$scope.data.newDriver.file = files[0];
						$scope.data.newDriver.acceptUploadFile = true;
					}
				});
			}
		};

		/************************************************************************************************************
			 *  WEB SERVICE DELETE
			 *************************************************************************************************************/
		$scope.deleteDriver = function (driver) {
			DriverService.deleteDriverById(driver.id)
				.then(() => {
					DriverService.getAllDriversByClient().then((response) => {
						$scope.data.drivers = response.data;
					});
					toastr.success("", "Conducteur supprimé");
					deleteModal.close();
				})
				.catch((error) => {
					toastr.error(error.data.message, "Problème lors de la suppression du conducteur");
				});
		};

		$scope.setDriverActiveStatus = function (driver, status) {
			DriverService.editDriverActiveStatus(driver.id, status).then((response) => {
				toastr.success("", "Le conducteur " + response.data.serviceNumber + " a été bien été mis à jour");
				DriverService.getAllDriversByClient().then((response) => {
					$scope.data.drivers = response.data;
				});
			}).catch((error) => {
				const data = error.data;
				let errorMessage = "Problème lors de la mise à jour du conducteur. ";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};
	}]
	);